import React, {useState} from 'react'
import axios from 'axios'

function ConceptoItemDetalle(props) {
  const concepto = props.concepto

  const [inputFile, setInputFile] = useState('')
  const [tituloInput, setTituloInput] = useState('')
  const [descInput, setDescInput] = useState('')

  let idElementoNum = concepto.idElement.split('-')[2]
  let tituloString = concepto.title + ''
  let descString = concepto.description + ''

  const onChangeImage = (event) => {
    setInputFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('home-concepto-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-concepto-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeTitulo = (event) => {
    setTituloInput(event.target.value)
    document.getElementById('ribbon-concepto-' + idElementoNum).classList.remove('d-none')
  }

  const onChangeDesc = (event) => {
    setDescInput(event.target.value)
    document.getElementById('ribbon-concepto-' + idElementoNum).classList.remove('d-none')
  }

  const onSubmit = () => {
    // if (!inputFile) {
    //   alert('Seleccione un archivo')
    //   return false
    // }

    const data = new FormData()

    for (let i = 0; i < inputFile.length; i++) {
      data.append('file[]', inputFile[i])
    }

    data.append('name', concepto.idElement)
    // data.append('titulo', document.getElementById('titulo-concepto-' + idElementoNum).value)
    data.append(
      'description',
      document.getElementById('descripcion-concepto-' + idElementoNum).value
    )

    let url = 'https://puntosurgdl.com/backend/'

    console.log(data)
    console.log(url)

    axios
      .post(url + 'uploadNewConcept.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
          document.getElementById('ribbon-concepto-' + idElementoNum).classList.add('d-none')
        },
        (error) => {
          alert(error)
        }
      )
  }

  return (
    <div className='col-lg-4 mb-8 conceptoitem' key={concepto.idElement}>
      <div className='card card-custom overlay overflow-hidden'>
        <div className='card-body p-0 ribbon'>
          <div id={'ribbon-concepto-' + idElementoNum} className='ribbon-label bg-danger d-none'>
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img
              src={concepto.url}
              alt=''
              className={'w-100 rounded img-carousel home-concepto-' + idElementoNum}
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-concepto-' + idElementoNum}
                name={'file-concepto-' + idElementoNum}
                className='input-image'
                onChange={(event) => onChangeImage(event)}
                accept='image/*'
              />
              <input
                id='button'
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() => document.getElementById('file-concepto-' + idElementoNum).click()}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <label className='form-label mt-6'>Titulo</label>
      <input
        id={'titulo-concepto-' + idElementoNum}
        name={'titulo-concepto-' + idElementoNum}
        className='form-control'
        type='text'
        defaultValue={tituloString}
        onChange={(e) => onChangeTitulo(e)}
      /> */}
      <label className='form-label mt-6'>Frase</label>
      <input
        id={'descripcion-concepto-' + idElementoNum}
        name={'descripcion-concepto-' + idElementoNum}
        className='form-control'
        type='text'
        defaultValue={descString}
        onChange={(e) => onChangeDesc(e)}
      />
      <div className='mt-4 float-end'>
        <button className='btn btn-primary btn-sm' onClick={() => onSubmit()}>
          Guardar
        </button>
        <button
          className='btn btn-danger btn-sm ms-2'
          onClick={() => props.deleteConcept(props.concepto.idElement)}
        >
          Eliminar
        </button>
      </div>
    </div>
  )
}

export {ConceptoItemDetalle}
